const hasUpperCase = (value: string) => {
  const UpperCaseChars = /[A-Z]/;
  return UpperCaseChars.test(value);
};

export const hasLowerCase = (value: string) => {
  const lowerCaseChars = /[a-z]/;
  return lowerCaseChars.test(value);
};

const hasNumber = (value: string) => {
  const numbersChars = /\d/;
  return numbersChars.test(value);
};

const hasSpecialChars = (value: string) => {
  const specialChars = /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
  return specialChars.test(value);
};

const isValidFullName = value => {
  const fullNamePattern = /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ\s]+$/;

  return fullNamePattern.test(value);
};

const isValidDate = (value: string) => {
  const datePattern = /^(\d{2})\/(\d{2})\/(\d{4})$/;
  const match = datePattern.exec(value);
  if (!match) {
    return false;
  }

  const [_, day, month, year] = match;
  const parsedYear = Number.parseInt(year, 10);
  const parsedMonth = Number.parseInt(month, 10);
  const parsedDay = Number.parseInt(day, 10);

  if (parsedYear < 1900 || parsedYear > 2100) {
    return false;
  }

  if (parsedMonth < 1 || parsedMonth > 12) {
    return false;
  }

  const daysInMonth = new Date(parsedYear, parsedMonth, 0).getDate();
  if (parsedDay < 1 || parsedDay > daysInMonth) {
    return false;
  }

  return true;
};

export default {
  hasUpperCase,
  hasLowerCase,
  hasNumber,
  hasSpecialChars,
  isValidDate,
  isValidFullName
};
